import * as React from 'react';
import { KeydownConfig } from 'owa-hotkeys';
import { getCommands } from 'owa-mail-hotkeys/lib/utils/MailModuleHotKeys';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';
import { listViewStore } from 'owa-mail-list-store';
import { isGroupTableQuery } from 'owa-group-utils';
import { showMailItemContextMenu } from 'owa-mail-list-actions/lib/actions/itemContextMenuActions';
import {
    keyboardCollapseConversation,
    singleSelectRow,
} from 'owa-mail-actions/lib/mailListSelectionActions';
import { isSecondLevelExpanded } from 'owa-mail-list-store/lib/selectors/isConversationExpanded';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { isFeatureEnabled } from 'owa-feature-flags';

export function setupMailListItemContainerKeys(props: {
    mailListTableProps: { tableViewId: string };
    mailListItemDataProps: { rowKey: string; shouldShowTwisty: boolean };
}): KeydownConfig[] {
    const keys = [];

    keys.push(
        {
            command: 'left',
            handler: () => keyboardCollapseConversation(props.mailListItemDataProps.rowKey),
        },
        {
            command: 'right',
            handler: () =>
                expandMailListItem(
                    props.mailListItemDataProps.shouldShowTwisty,
                    props.mailListItemDataProps.rowKey,
                    props.mailListTableProps.tableViewId
                ),
        }
    );

    if (!isFeatureEnabled('tri-globalHotkeys')) {
        keys.push(
            {
                command: getCommands().moveToFolder,
                handler: evt =>
                    moveToShortcutHandler(
                        evt,
                        props.mailListTableProps.tableViewId,
                        MailListContextMenuType.MoveTo
                    ),
            },
            {
                command: getCommands().categorize,
                handler: evt =>
                    moveToShortcutHandler(
                        evt,
                        props.mailListTableProps.tableViewId,
                        MailListContextMenuType.Categorize
                    ),
            }
        );
    }

    return keys;
}

// TODO update for two level expansion
function expandMailListItem(shouldShowTwisty: boolean, rowKey: string, tableViewId: string) {
    if (!shouldShowTwisty || isSecondLevelExpanded(rowKey)) {
        // no item part to expand or the conversation is already expanded
        return;
    }

    // perform the same action as clicking on the twisty
    singleSelectRow(
        listViewStore.tableViews.get(tableViewId),
        rowKey,
        true /* isUserNavigation */,
        MailListItemSelectionSource.MailListItemTwisty
    );
}

function moveToShortcutHandler(
    evt: React.MouseEvent<HTMLElement> | React.KeyboardEvent<Element> | KeyboardEvent,
    tableViewId: string,
    ContextMenuType: MailListContextMenuType
) {
    const tableView = listViewStore.tableViews.get(tableViewId);

    // moving messages shorcut is disabled for groups
    if (isGroupTableQuery(tableView.tableQuery)) {
        return;
    }

    const selectedRows = tableView.selectedRowKeys;
    if (selectedRows.size > 0) {
        const clientRect = (evt.currentTarget as Element).getBoundingClientRect();
        showMailItemContextMenu({ x: clientRect.right, y: clientRect.top }, ContextMenuType);
    }
}
